import { h, Component } from "preact";
import { css } from "emotion";
import Button from "./Button";
import IconArrowDown from "../assets/images/icon-arrow-down-solid.svg";
const dropDownStyles = css({
  position: "relative",
  display: "inline-block",
  "#dropdown-content": {
    display: "none",
    position: "absolute",
    backgroundColor: "#ffffff",
    borderRadius: 4,
    minWidth: "160px",
    boxShadow: "0 1px 10px 0 rgba(9, 30, 66, 0.13)",
    zIndex: 1,
    padding: "12px 12px"
  },
  ":hover #dropdown-content, :active #dropdown-content": {
    display: "block"
  },
  button: {
    color: "#323232 !important",
    borderColor: "#8e99a8 !important",
    fontSize: 14,
    "&:hover": {
      backgroundColor: "white !important",
      border: "solid 1px #8e99a8"
    }
  }
});

const buttonStyle = css({
  display: "inherit",
  "@media (max-width:600px)": {
    display: "none"
  }
});

const linkStyle = css({
  display: "none",
  "@media (max-width:600px)": {
    display: "flex"
  }
});

const linkStyles = css({
  color: "black",
  textDecoration: "none",
  display: "block",
  cursor: "pointer",
  marginBottom: 12,
  ":last-child": {
    marginBottom: 0
  }
});

const ButtonDropDown = ({
  dropDownOptions,
  buttonLabel,
  buttonProps,
  dataCY
}) => {
  return (
    <div className={dropDownStyles}>
      <div className={buttonStyle}>
        <Button {...buttonProps} data-cy={dataCY}>
          {buttonLabel}
        </Button>
      </div>
      <div className={linkStyle}>
        <h4 style={{ marginBottom: 0, marginTop: 4 }}>{buttonLabel}</h4>
        <img src={IconArrowDown} />
      </div>
      <div id={"dropdown-content"}>
        {dropDownOptions.map(option => {
          return (
            <a
              onClick={option.action}
              className={linkStyles}
              data-cy={option.dataCY}
            >
              {option.label}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default ButtonDropDown;



// WEBPACK FOOTER //
// ./components/ButtonDropDown.js